import { useContext, useEffect, useState } from "react";
import {
	GET_DESI_MOVIE_BY_ID,
	GET_DESI_MOVIE_COMMENT_BY_ID,
	GET_FREE_CLASSIFIED_BY_ID,
	POST_CLASSIFIED_COMMENT,
	POST_DESI_MOVIE_COMMENTS,
	fetchData,
} from "../../components/Service";
import { Link, useParams } from "../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../components/Context";
import _ from "lodash";
import moment from "../../../node_modules/moment/moment";
import { scrollTop } from "../../components/Helper";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Share from "../../components/Share";

const DesiPageDetails = () => {
	const { desi_page_id } = useParams();
	const [context] = useContext(Context);
	const [data, setData] = useState();
	const [comment, setComment] = useState();
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const getDetails = (reid) => {
		let payload = {
			id: reid,
		};

		fetchData(GET_DESI_MOVIE_BY_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setData(res?.data);
			} else {
				setData();
			}
		});
	};

	const getComments = (reid) => {
		let payload = {
			id: reid,
		};

		fetchData(GET_DESI_MOVIE_COMMENT_BY_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setComment(res?.data?.data);
			} else {
				setComment();
			}
		});
	};

	const postComment = (data) => {
		let payload = {
			user_id: context?.user?.user_id,
			id: desi_page_id,
			comment: data.description,
		};

		fetchData(POST_DESI_MOVIE_COMMENTS, "POST", payload, true, false, (res) => {
			if (res.status) {
				reset();
				getComments(desi_page_id);
			} else {
				toast.error("Unable to post comment.");
			}
		});
	};

	useEffect(() => {
		scrollTop();
		if (desi_page_id) {
			getDetails(desi_page_id);
			getComments(desi_page_id);
		}
	}, [desi_page_id]);
	return (
		<div class="col-lg-12">
			<div class="card card-forum ">
				<div class="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-12">
								<h4 class="text-white d-flex mb-0 py-2">{_.startCase(data?.name)}</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white p-1">
					<div class="card mb-3">
						<div className="card-header p-1">
							<ul className="point-list">
								<li>
									<span>
										<i class="fi fi-sr-eye"></i>
									</span>
									{data?.total_views}
								</li>
								<li>
									<span>
										<i class="fi fi-rr-calendar-lines"></i>
									</span>{" "}
									{data?.created_at ? moment(data?.created_at).format("DD-MMM-YYYY") : ""}
								</li>
							</ul>
						</div>
						<div class="row g-0 align-items-stretch">
							<div class="col-xl-6">
								<img src={data?.image ? data?.image : "/assets/images/no-image.jpg"} class="img-fluid rounded-3" />
							</div>
							<div class="col-xl-6">
								<div class="card-body h-100">
									<h6 class="card-title">Contact Person:</h6>
									<div className="table-responsive">
										<table className="table table-borderless table-sm">
											<tr>
												<td className="ps-0">
													<ul className="point-list1">
														<li>
															<spab className="fw-light"> Name:</spab>
														</li>
													</ul>
												</td>

												<td>{data?.name}</td>
											</tr>
											<tr>
												<td className="ps-0">
													<ul className="point-list1">
														<li>
															<spab className="fw-light">Additional Info:</spab>
														</li>
													</ul>
												</td>

												<td>{data?.additional_info}</td>
											</tr>
											<tr>
												<td className="ps-0" style={{ width: "140px" }}>
													<ul className="point-list1">
														<li>
															<spab className="fw-light">Start Date: </spab>
														</li>
													</ul>
												</td>

												<td>{data?.start_date}</td>
											</tr>
											<tr>
												<td className="ps-0" style={{ width: "140px" }}>
													<ul className="point-list1">
														<li>
															<spab className="fw-light">Return Date: </spab>
														</li>
													</ul>
												</td>

												<td>{data?.end_date}</td>
											</tr>
											<tr>
												<td className="ps-0">
													<ul className="point-list1">
														<li>
															<spab className="fw-light">Check On </spab>
														</li>
													</ul>
												</td>

												<td className="fw-bold">
													{data?.url ? (
														<Link to={data?.url} target="_blank">
															{data?.url}
														</Link>
													) : (
														""
													)}
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card-body h-100">
									<Share url={`https://${process.env.REACT_APP_DOMAIN_URL}/desi-page/${data?.id}`}
									id={data?.id}
									type="desi-page"
									/>
								</div>
							</div>
						</div>
					</div>
					{comment?.data && comment.data.length > 0 && (
						<div className="row">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header">
										<h6>Comments ({comment?.data?.length})</h6>
									</div>
									<div className="card-body">
										<ul className="comments-list">
											{comment?.data?.map((item) => (
												<li key={item?.id}>
													<span className="img-user">{item?.user?.image ? <img src={item?.user?.image} /> : <img src="/assets/images/slide1-1480.jpg" />}</span>
													<h6>
														{item?.user?.first_name} {item?.user?.last_name}
													</h6>
													<p className="mt-1">{item?.comment}</p>
												</li>
											))}
										</ul>
									</div>
								</div>
							</div>
						</div>
					)}
					<div className="row my-2">
						<div className="col-md-12">
							<div className="card">
								<div className="card-header">
									<h6>Post Comments</h6>
								</div>
								<div className="card-body">
									{context?.userToken ? (
										<div class="mb-3">
											<label for="Respond" class="form-label">
												Respond to Talk
											</label>
											<form onSubmit={handleSubmit(postComment)}>
												<textarea
													class="form-control"
													id="Respond"
													rows="5"
													{...register("description", {
														required: { value: true, message: "Please write some comment." },
													})}
												></textarea>
												<div className="row">
													<div className="col-md-6">{errors.description && <div class="invalid-feedback d-block">{errors.description.message}</div>}</div>
													<div className="col-md-6">
														<div className="text-end mt-2">
															<button class="btn btn-light font13 d-inline-flex align-items-center me-2" onClick={() => reset()}>
																Cancel
															</button>
															<button class="btn btn-warning font13 d-inline-flex align-items-center" type="submit">
																Post Comment <i class="fi fi-rr-arrow-small-right ms-2"></i>
															</button>
														</div>
													</div>
												</div>
											</form>
										</div>
									) : (
										<div class="text-center text-danger">Please <a href="#!" className=" fw-bold" data-bs-toggle="modal" data-bs-target="#loginModal">
										Login
									</a> to post comment.</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DesiPageDetails;
